import { gigaParty } from "../party";

export const addUserMessage = (message: { role: 'user', context: string, id: string }) => {
    gigaParty.send(JSON.stringify({
        key: 'gigakit.shell.ai.add_user_message',
        id: message.id,  // Include id here
        data: message.context
    }));
}